import { post } from "./HttpClient";
import { GET_FAVORITES } from "./ApisRoutes";

export const GetFavoritesService = (params) => {
  return new Promise((resolve, reject) => {
    post(GET_FAVORITES, params)
      .then((response) => {
        const _response = response?.data;
        resolve(_response);
      })
      .catch((error) => {
        console.log(error, "login response error");
        reject(error);
      });
  });
};
